import { Component, OnInit, Input } from '@angular/core';
import { DrawerComponent } from '../common/utilities/drawer/drawer.component';
import { ViewChildren, QueryList } from '@angular/core';
import { NeedHelpService } from './needHelp.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { SharedService } from 'src/app/common/services/sharedService';
import { PlanProductListingService } from 'src/app/planListingModule/planProductListing/planProductListing.service';

export class Notifier {
  valueChanged: (data: string) => void = (d: string) => { };
}

@Component({
  selector: 'need-help',
  templateUrl: './needHelp.template.html',
  styleUrls: ['./needHelp.style.scss'],
  providers: [NeedHelpService],
})
export class NeedHelpComponent implements OnInit {
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  showDrawer = false;
  showLoader: boolean;
  planServiceError: string;
  applicationId: any;
  @Input() notify = new Notifier();
  @Input() displayNeedHelpText: boolean = true; // Hide content in case of mobile
  constructor(
    private _needHelpService: NeedHelpService,
    private _sessionHandlerService: SessionHandlerService,
    private planProductListingService: PlanProductListingService,
    public sharedService: SharedService,
  ) {

  }

  ngOnInit() {
    this.applicationId = this._sessionHandlerService.GetSession('loanApplicationId');
     this.notify.valueChanged = (popUpId: string) => {
      this.openDrawer(popUpId);
    };

  }
  // open drawer
  public openDrawer(itemId) {
    this.showDrawer = true;
    this.drawer.filter((item, index) => {
      return (itemId === item.drawerId);
    })[0].open();
  }
  // close drawer
  public hideDrawer(itemId) {
    this.showDrawer = false;
    this.drawer.filter((item, index) => {
      return (itemId === item.drawerId);
    })[0].close();
  }
  public clickToCall() {
    this.showLoader = true;
    const requestData = {
      payload: {
        'leadType': 'dropoff',
        'applicationId': this.applicationId
      },
    };
    this._needHelpService.PostClickToCall(requestData).subscribe((response) => {
      this.showLoader = false;
      if (!response.error && response.payload) {
      } else {
        this.planServiceError = 'Something went wrong. Please try again later';
      }
    },
      (error) => {
        this.showLoader = false;
      });
  }

  public onExplore() {
    this.sharedService.onExplore('INSINSURANCE', 'HOME');
  }
}

